/**
 * The labels used to insert the advance select code
 */
export const advanceSelectLoopLabel = '<selectAdvanceLoopTemplate>';
export const advanceSelectOuterLabel = '<selectAdvanceOuterTemplate>';
export const dispatchEventAdvanceSelectLabel = '<dispatchEventAdvanceSelect>';

/**
 * The advance select code
 * @param {string}  optionElementName - the name of the html element variable
 * @param {string}  dataName - the name of the data used to give the option a value
 * @param {string}  propert - the property of the data
 */
export const advanceSelectTemplate = (optionElementName, dataName, property) =>
  `${optionElementName}.value=${dataName}.${property};`;

export default { advanceSelectLoopLabel, advanceSelectOuterLabel, advanceSelectTemplate };
